import { render } from "./routeToAgora.vue?vue&type=template&id=3a33139b&scoped=true"
const script = {}

import "./routeToAgora.vue?vue&type=style&index=0&id=3a33139b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a33139b"]])

export default __exports__